import React, { Component } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Link, Redirect} from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import classnames from 'classnames';
import axios from 'axios';
import ModalVideo from 'react-modal-video';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import MetaTags from 'react-meta-tags';

import Helmet from 'react-helmet';

import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    InputGroup,
    InputGroupAddon,
    Button,
    Input,
    UncontrolledTooltip,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    CardTitle,
    CardText,
    Table,
    Progress,
    Media
} from 'reactstrap';

// import emotion
import { css } from 'emotion';

// import icons
import {FaFacebook, FaTwitter} from "react-icons/fa";
import { FaLinkedin  } from "react-icons/fa";

// import react-custom-share components
import { ShareButtonRectangle, ShareBlockStandard } from 'react-custom-share';

import LayoutMaster from "../../../views/layout/Master";
import {layout} from "../../../../ts-helpers/decorators";

import { FilePond, registerPlugin, create } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import swal from "sweetalert2";
import Loading from "../../includes/Loading";
import i18next from "./HomePage";
import {Translation} from "react-i18next";
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFilePoster);

import social_1   from "../../../../assets/img/site/Social/Asset-16.svg";
import social_2   from "../../../../assets/img/site/Social/Asset-17.svg";
import social_3   from "../../../../assets/img/site/Social/Asset-18.svg";
import social_4   from "../../../../assets/img/site/Social/Asset-19.svg";
import social_5   from "../../../../assets/img/site/Social/Asset-23.svg";
import Logo_b from "../../../../assets/img/site/Logo.png";


@layout(LayoutMaster)
@(connect((state: any) => {
    return {
        isLogged: state.AuthReducer.isLogged,
        user: state.AuthReducer.user,
    };
}) as any)

export default class Tool extends Component<any>{
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    filePond = null;

    state = {
        tool_image:'',
        tool_title:'',
        tool_description:'',
        tool_facebook_link:'',
        tool_twitter_link:'',
        tool_linkedin_link:'',
        tool_email_link:'',
        tool_site_link:'',
        tool_text:'',
        button_name:'',
        prisingButton:'',

        tool_features:[],
        tool_keywords:[],
        tool_videos:[],

        loading: false,
        updated: false,

        activeTab: '1',
        isOpenVideo: false,
        activeVideoId: '',

        toolSave:false,
        toolVote:false,
        showMore:false,

        feature_votes_count: 0,
        copyUrl_e:false
    };

    constructor(props: Map<any, any>) {
        super(props);
         this.filePond = React.createRef();
    }

     componentDidMount() {
        const { id } = this.props.match.params;
        this.getData(id);
        this.props.onRef(this);
    }

    componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
        if(nextProps.match.params.id !== this.props.match.params.id){
            this.getData(nextProps.match.params.id);
        }
    }

    @autobind
    getData(id){
        const user = JSON.parse(localStorage.getItem('logged_user'));
        http.get(`/tools/tool/${id}`)
        .then(response => response.json())
        .then((data) => {

            let kk = data.keywords.split(',');
            let t = [];
            kk.map((e, i) => {
                t.push(e)
            })

            this.setState({
                loading: false,
                updated: false,
                tool_image:data.t_image,
                tool_title:data.t_title,
                tool_description:data.t_description,
                tool_facebook_link:data.t_facebook,
                tool_twitter_link:data.t_twitter,
                tool_linkedin_link:data.t_linkedin,
                tool_email_link:data.t_email,
                tool_site_link:data.t_site,
                tool_text:data.t_text,
                tool_features:data.features,
                tool_keywords:t,
                button_name:data.t_button_name,
                prisingButton:data.t_prising_button,
                feature_votes_count:data.t_features_all_count,
            },()=>{
                if(user){
                    this.getUser();
                    this.getVote();
                }
                this.getVideoInfo(data.videos);
            });

        });
    }

    @autobind
    getUser(){
        const user = JSON.parse(localStorage.getItem('logged_user'));
        const { id } = this.props.match.params;
        http.get(`/users/getSaveTool/${user.id}/${id}`)
        .then(response => response.json())
        .then((data) => {
            if(data.status == 'success'){
                this.setState({
                    toolSave:true,
                });
            }else{
                this.setState({
                    toolSave:false,
                });
            }

        });
    }

    @autobind
    getVote(){
        const user = JSON.parse(localStorage.getItem('logged_user'));
        const { id } = this.props.match.params;
        http.get(`/users/getVoteTool/${user.id}/${id}`)
            .then(response => response.json())
            .then((data) => {
                if(data.status == 'success'){
                    this.setState({
                        toolVote:true,
                    });
                }else{
                    this.setState({
                        toolVote:false,
                    });
                }

            });
    }

    @autobind
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    @autobind
    getVideoInfo(ev) {
        //const {isLogged, user}=this.props;
        var videos = [];
        ev.map((e,i) => {

            axios.get('https://www.googleapis.com/youtube/v3/videos?part=snippet&id='+e+'&key=AIzaSyA-QDAEPslFn5raMDtBHOat_caChWoBC0g')
            .then( (response) => {
                videos.push({
                    image:response.data.items[0].snippet.thumbnails.high['url'],
                    title:response.data.items[0].snippet.title,
                    description:response.data.items[0].snippet.description,
                    videoId:e,
                })
                this.setState({
                    tool_videos:videos
                });
            })
            .catch( (error) => {
                console.log(error);
            });
        })
    }

    @autobind
    openModal(e:any){
        this.setState({
            isOpenVideo: true,
            activeVideoId: e
        })
    }

    @autobind
    saveTool(){
        const { id } = this.props.match.params;
        const user = JSON.parse(localStorage.getItem('logged_user'));
        var toolSave = this.state;
        http.get (`/users/addTool/${user.id}/${id}`)
            .then(response => response.json())
            .then((data) => {
                if(data.status == "add"){
                    this.setState({
                        toolSave:true,
                    });
                }else{
                    this.setState({
                        toolSave:false,
                    });
                }

            });
    }

    @autobind
    saveVote(){
        const { id } = this.props.match.params;
        const user = JSON.parse(localStorage.getItem('logged_user'));
        var toolVote = this.state;
        http.get (`/users/vote/${user.id}/${id}`)
            .then(response => response.json())
            .then((data) => {
                if(data.status == "add"){
                    this.setState({
                        toolVote:true,
                    });
                }else{
                    this.setState({
                        toolVote:false,
                    });
                }

            });
    }

    @autobind
    saveFeature(e){
        const feature_id = e;
        const { id } = this.props.match.params;
        const user = JSON.parse(localStorage.getItem('logged_user'));
        http.get (`/tools/featureVote/${user.id}/${id}/${feature_id}`)
            .then(response => response.json())
            .then((data) => {
                this.getData(id);
            });
    }

    @autobind
    hashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        var c = (hash & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return "#"+"00000".substring(0, 6 - c.length) + c;
    }


    @autobind
    getPercent(feature) {
        const {feature_votes_count} = this.state;
        return (feature.votes.length/feature_votes_count)*100
    }

    @autobind
    showMore(){
        this.setState({
            showMore:true,
        });
    }

    @autobind
    hideMore(){
        this.setState({
            showMore:false,
        });
    }

    @autobind
    copyUrlChange(){
        this.setState({
            copyUrl_e:true,
        });
        setTimeout(() => {
            this.setState({copyUrl_e: false});
        }, 2000)
    }

    render() {
        const {isLogged, user}=this.props;

        const {
            updated,
            loading,
            tool_image,
            tool_title,
            tool_description,
            tool_facebook_link,
            tool_twitter_link,
            tool_linkedin_link,
            tool_site_link,
            tool_email_link,
            tool_text,
            tool_features,
            tool_keywords,
            button_name,
            tool_videos,
            isOpenVideo,
            activeVideoId,
            toolSave,
            toolVote,
            showMore,
            prisingButton,
            copyUrl_e
        } = this.state;

        const userRole = JSON.parse(localStorage.getItem('logged_user'));
        const query = localStorage.getItem('query');
        const copyUrl = window.location.href;

        const shareBlockProps = {
            url: window.location.href,
            button: ShareButtonRectangle,
            buttons: [
                { network: 'Facebook', icon: FaFacebook },
                { network: 'Linkedin', icon: FaLinkedin },
                { network: 'Twitter',  icon: FaTwitter},
            ],
            text: tool_title,
            longtext: tool_description,
        };

         if(!showMore){
             var sortedFeatures = tool_features.sort((a, b) => (a.votes.length > b.votes.length) ? -1 : 1).slice(0, 3)
         }else{
             var sortedFeatures = tool_features.sort((a, b) => (a.votes.length > b.votes.length) ? -1 : 1)
         }

        return (
            <Container fluid className="tool_info_block">

                <Helmet>
                    <title>{tool_title} / Skillers.co</title>
                    <meta name="keywords" content={tool_keywords.join()} />
                    <meta name="description" content={tool_description} />
                </Helmet>

                {/*<Helmet>*/}
                {/*    <title>{tool_title} / Skillers.co</title>*/}
                {/*    <meta name="keywords" content={tool_keywords.join()} />*/}
                {/*    <meta name="description" content={tool_description} />*/}
                {/*    <meta name="og:url"  content={window.location.href} />*/}
                {/*    <meta name="og:type"  content="article" />*/}
                {/*    <meta name="og:title" content={`${tool_title} / Skillers.co`} />*/}
                {/*    <meta name="og:image" content="data:image/png;base64,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" />*/}
                {/*    <meta name="og:description" content={tool_description} />*/}
                {/*</Helmet>*/}

                {
                    loading ? <Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row> :
                        <div>
                            <Row>
                                <Col className="col-sm-12 tool_view_block">
                                    <Col className="col-sm-3 tool_view_left_block">
                                        <Row>
                                            <Col className="col-xs-6 tool_view_back">
                                                <Link to={Route.toUrl('search',{query:query})}>
                                                    <i className="fa fa-angle-left" />
                                                </Link>
                                            </Col>
                                            {
                                                copyUrl_e ?
                                                    <Col className="col-xs-6 copy_url_text_style">
                                                        <span>Copied</span>
                                                    </Col>
                                                    :
                                                    <Col className="col-xs-6 tool_view_copyUrl">
                                                        <CopyToClipboard text={copyUrl}>
                                                            <Link to="#" onClick={this.copyUrlChange} className="tooltip_2">
                                                                <i className="fa fa-files-o" />
                                                                <span className="tooltiptext_2">Copy profile url to clipboard</span>
                                                            </Link>
                                                        </CopyToClipboard>
                                                    </Col>
                                            }
                                        </Row>
                                        <Row>
                                            <Col className="col-sm-offset-2 col-sm-8 tool_view_image text-center">
                                                <img src={`${http.getDomain()}/${tool_image}`} alt={tool_title} />
                                            </Col>
                                            <Col className="col-sm-12 tool_view_title">
                                                {tool_title}
                                            </Col>
                                            <Col className="col-sm-12 tool_view_description">
                                                {tool_description}
                                            </Col>
                                            <Col className="col-sm-12 tool_view_savedUpvote_block">
                                                <Col className="col-sm-6 view_saved">
                                                    {
                                                        userRole && userRole.role == 'user' ?

                                                                <Link to="#" onClick={this.saveTool}>
                                                                    <div className={`${toolSave ? "tool_view_saved_1" : "tool_view_saved"}`}>
                                                                        {
                                                                            toolSave == true ?
                                                                                <span>Saved</span>
                                                                            :
                                                                                <span>Save</span>
                                                                        }
                                                                    </div>
                                                                </Link>

                                                        : ''
                                                    }
                                                </Col>
                                                <Col className="col-sm-6 view_upvote">
                                                    {
                                                        userRole && userRole.role == 'user' ?
                                                            toolVote == true ?
                                                                <Link to="#" onClick={this.saveVote}>
                                                                    <div className="tool_view_downvote">
                                                                        <i className="fa fa-caret-down" /> Downvote
                                                                    </div>
                                                                </Link>
                                                                :
                                                                <Link to="#" onClick={this.saveVote}>
                                                                    <div className="tool_view_upvote">
                                                                        <i className="fa fa-caret-up" /> Upvote
                                                                    </div>
                                                                </Link>
                                                        : ''
                                                    }
                                                </Col>
                                            </Col>
                                            <Col className="col-sm-12 tool_view_socIcon_block">
                                                {
                                                    tool_facebook_link &&
                                                        <Col className="col-xs-2 view_socIcon">
                                                            <a href={tool_facebook_link} target="_blank">
                                                                <img src={social_4} alt=""/>
                                                            </a>
                                                        </Col>
                                                }
                                                {
                                                    tool_twitter_link &&
                                                        <Col className="col-xs-2 view_socIcon">
                                                            <a href={tool_twitter_link} target="_blank">
                                                                <img src={social_3} alt=""/>
                                                            </a>
                                                        </Col>
                                                }
                                                {
                                                    tool_linkedin_link &&
                                                        <Col className="col-xs-2 view_socIcon">
                                                            <a href={tool_linkedin_link} target="_blank">
                                                                <img src={social_1} alt=""/>
                                                            </a>
                                                        </Col>
                                                }
                                                {
                                                    tool_email_link &&
                                                        <Col className="col-xs-2 view_socIcon tooltip_1">
                                                            <a href={"mailto:"+tool_email_link}>
                                                                <img src={social_5} alt=""/>
                                                            </a>
                                                            <span className="tooltiptext_1">{tool_email_link}</span>
                                                        </Col>
                                                }
                                                {
                                                    tool_site_link &&
                                                        <Col className="col-xs-2 view_socIcon">
                                                            <a href={tool_site_link} target="_blank">
                                                                <img src={social_2} alt=""/>
                                                            </a>
                                                        </Col>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="col-sm-7 tool_view_content_block">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink id="item_info_tabs" className={classnames({ active: this.state.activeTab === '1' })}
                                                         onClick={() => { this.toggle('1'); }}> <span>Profile</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink id="item_info_tabs" className={classnames({ active: this.state.activeTab === '2' })}
                                                         onClick={() => { this.toggle('2'); }}> <span>Tutorials</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink id="item_info_tabs" className={classnames({ active: this.state.activeTab === '3' })}
                                                         onClick={() => { this.toggle('3'); }}> <span>More</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent id="my_tab_content" activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                                <Row className="tool_view_tab_content_block">
                                                    <Col className="col-xs-12 tool_view_profile_title">Features Ranking</Col>
                                                    {
                                                        sortedFeatures.map((feature,i) => {
                                                            return (
                                                                <Col key={i} className="col-sm-12 tool_view_profile_feature">
                                                                    <Progress color="info" value={this.getPercent(feature)}>
                                                                        <Row>
                                                                            <Col className="col-sm-12 feature_name_style ">
                                                                                {feature.feature}
                                                                            </Col>
                                                                        </Row>
                                                                    </Progress>
                                                                    <div className="feature_voteUpDown_style">
                                                                        <span>
                                                                            {
                                                                                userRole&& userRole.role == 'user' ?
                                                                                    feature.votes.length?"+"+feature.votes.length:""
                                                                                : ''
                                                                            }
                                                                        </span>
                                                                        {
                                                                            userRole && userRole.role == 'user' ?
                                                                                feature.votes.indexOf(userRole.id) > -1  ?
                                                                                    (
                                                                                        <Link to="#" className="fe_do" onClick={() => this.saveFeature(feature._id)}>
                                                                                            <i className="fa fa-caret-down" /> Downvote
                                                                                        </Link>
                                                                                    )
                                                                                :
                                                                                    (
                                                                                        <Link to="#" className="fe_up" onClick={() => this.saveFeature(feature._id)}>
                                                                                            <i className="fa fa-caret-up" /> Upvote
                                                                                        </Link>
                                                                                    )
                                                                            :   ''
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        tool_features.length > 3 &&
                                                            <Col className="col-sm-12 feature_more_link_block">
                                                                {
                                                                    !showMore ?
                                                                        <Link to="#" className="feature_more_link" onClick={this.showMore}>
                                                                            More
                                                                        </Link>
                                                                    :
                                                                        <Link to="#" className="feature_more_link" onClick={this.hideMore}>
                                                                            Hide
                                                                        </Link>
                                                                }
                                                            </Col>
                                                    }
                                                </Row>
                                                <Row className="tool_view_tab_content_profile_tags_block">
                                                    <Col className="col-xs-12 tool_view_profile_tags">Tags</Col>
                                                        {
                                                            tool_keywords.map((keyword,i) => {
                                                                return (
                                                                    <Col key={i} className="col-xs-12 col-sm-4 tool_view_profile_tags_items">
                                                                        <div style={{background:this.hashCode(keyword)}}>{keyword}</div>
                                                                    </Col>
                                                                )
                                                            })
                                                        }
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                {
                                                    tool_videos.map((e,i) => {
                                                        return (
                                                            <Row key={i} className="tool_view_tab_content_video_block">
                                                                <Col className="col-sm-3">
                                                                    <img className="video_image" src={e.image} alt="" onClick={()=>this.openModal(e.videoId)}/>
                                                                </Col>
                                                                <ModalVideo
                                                                    channel='youtube'
                                                                    isOpen={isOpenVideo}
                                                                    videoId={activeVideoId}
                                                                    onClose={() => this.setState({isOpenVideo: false})}
                                                                />
                                                                <Col className="col-sm-9">
                                                                    <Row>
                                                                        <Col className="col-sm-12 video_title">{e.title}</Col>
                                                                        <Col className="col-sm-12 video_description">{e.description}</Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    })
                                                }
                                            </TabPane>
                                            <TabPane tabId="3">
                                                <Row className="tool_view_tab_content_block">
                                                    <Col className="col-xs-12 tool_view_tab_more_text">
                                                        <div dangerouslySetInnerHTML={ { __html: tool_text } }></div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </TabContent>
                                    </Col>
                                    <Col className="col-sm-2 tool_view_pricingFree_block">
                                        <Row>
                                            <Col className="col-xs-12">
                                                <a href={prisingButton} target="_blank">
                                                    <div className="tool_view_link_pricing">
                                                        Pricing
                                                    </div>
                                                </a>
                                            </Col>
                                            <Col className="col-xs-12">
                                                <Link to="#">
                                                    <div className="tool_view_link_free">{button_name}</div>
                                                </Link>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="col-xs-12 social_icons_block">
                                                <div className="social_icons_ShareName"><i className="fa fa-share"/> Share</div>
                                                <ShareBlockStandard {...shareBlockProps} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </div>
                }
            </Container>
        );
    }
}


